import { render, staticRenderFns } from "./index4.vue?vue&type=template&id=b404c994&scoped=true&"
import script from "./index4.vue?vue&type=script&lang=js&"
export * from "./index4.vue?vue&type=script&lang=js&"
import style0 from "./index4.vue?vue&type=style&index=0&id=b404c994&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b404c994",
  null
  
)

export default component.exports